import { MessageWithErrorExtras } from "@/common/components/ModalMessageWithErrorExtras"
import { AxiosError } from "axios"
import { Dispatch, SetStateAction } from "react"
import { FieldValues, Path, UseFormSetError } from "react-hook-form"
import { ErrorsMapper } from "../services/errorsMapper"

export class FormTransformers {
  static errorsTransformer<T extends FieldValues>({ setError, setMessages, transformer }: {
    setError?: UseFormSetError<T>,
    setMessages?: (message: string[] | boolean) => void,
    transformer?: (errors: Record<string, string[]>) => any[],
  }) {
    return (
      error: AxiosError
    ) => {
      const data = error?.response?.data as {
        errors: Record<string, string[]>,
        error_extras: {
          parsed_reason: string
          raw_reason: string
        } | null
      }
      const { errors } = data

      if (!errors || !Object.keys(errors).length) {
        return
      }

      const transformedErrors = transformer?.(errors) || ErrorsMapper.default()(errors)

      if (transformedErrors.length && setError) {
        transformedErrors.map((error) => {
          const key = Object.keys(error)?.[0]
          setError(key as Path<T>, { message: error[key] })
        })
      }

      if ((errors?.base?.length || (transformedErrors.length && transformedErrors.some((error) => Object.keys(error).some((key) => key === '_base')))) && setMessages) {
        const messages = [
          ...(errors.base || []),
          ...(transformedErrors.filter((error) => Object.keys(error).some((key) => key === '_base')).flatMap((error) => error._base) || []),
        ]

        if (data.error_extras?.parsed_reason) {
          messages.push(data.error_extras.parsed_reason)
        }

        setMessages(messages)
      }
    }
  }

  static errorsWithExtrasTransformer({
    setErrors,
  }: {
    setErrors: Dispatch<SetStateAction<MessageWithErrorExtras | boolean>>
  }) {
    return (error: AxiosError) => {
      const data = error?.response?.data as {
        errors: Record<string, string[]>
        error_extras: {
          parsed_reason: string
          raw_reason: string
        } | null
      }

      const errors: MessageWithErrorExtras = {
        messages: [],
        errorExtras: null,
      }

      const {
        errors: { base },
      } = data

      if (!!base && base?.length) {
        errors.messages.push(...base)
      }

      if (data.error_extras) {
        errors.errorExtras = data.error_extras
      }

      setErrors(errors)
    }
  }
}
